export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-windows-1.373bd549.svg";